<template>
  <TemplateView>
    <div class="container">
      <div class="wrap">
        <transition-group name="fade" mode="out-in" appear>
          <LoadingAnimation v-if="loadingGroupShow" :key="0" />
          <div class="wrap_row wrap_row--grid" v-if="!loadingGroupShow" :key="1">
            <div class="items">
              <div class="d-grid grid-col-max-max gap-5 align-center mb-2">
                <h4 class="f24 fw500">
                  {{
                    localStorage.translations.pages.personnel_department[
                      'employees-group_sections'
                    ]['sotrudniki'] + ':'
                  }}
                </h4>
                <BaseTooltip
                  v-if="employeeGroupChat || userIsReadyToCreateChat"
                  :tooltip="
                    employeeGroupChat
                      ? localStorage.translations.pages.chat.all.employeegroup_chat
                      : localStorage.translations.pages.chat.all.create_employeegroup
                  "
                >
                  <BaseButton
                    color="primary"
                    @click="onClickGroupChat"
                    depressed
                    class="rounded-lg"
                    default_icon="chat-main"
                    minimalize
                    icon_only
                  />
                </BaseTooltip>
              </div>

              <BaseCard classBody="box box--employee">
                <EmployeesGroupSelectTable
                  v-if="
                    employeeGroupShow &&
                    employeeGroupShow.employees &&
                    employeeGroupShow.employees.length &&
                    !loadingGroupShow
                  "
                  :items="employeeGroupShow.employees"
                />
                <Plug
                  v-else-if="
                    employeeGroupShow &&
                    employeeGroupShow.employees &&
                    !employeeGroupShow.employees.length &&
                    !loadingGroupShow
                  "
                />
              </BaseCard>
              <div
                v-if="
                  $userCheckAccess({
                    abilities: 'edit_hr',
                  })
                "
                class="mt-7"
              >
                <EmployeesGroupCreateAndEditModal />
              </div>
            </div>
            <div class="items">
              <h4 class="f24 fw500 mb-5">
                {{
                  localStorage.translations.pages.personnel_department['employees-group_sections'][
                    'navyki'
                  ] + ':'
                }}
              </h4>
              <BaseCard classBody="box">
                <v-treeview
                  v-if="skillsList[0].children.length && !loading"
                  class="treeview noneClosed"
                  v-model="typesSelected"
                  :items="skillsList"
                  item-key="id"
                  selection-type="leaf"
                  selectable
                  return-object
                  open-all
                  shaped
                />
                <Plug v-if="!skillsList[0].children.length && !loading" />
              </BaseCard>
              <div
                v-if="
                  $userCheckAccess({
                    abilities: 'edit_hr',
                  })
                "
                class="mt-7"
              >
                <BaseButton
                  @click="onUpdateActiveSkills"
                  :text="localStorage.translations.pages.common['buttons']['sohranit']"
                  default_icon="button-save"
                />
              </div>
            </div>
          </div>
          <div class="wrap_row" v-if="!loadingGroupShow" :key="2">
            <EmployeesGroupSelectModalWorkTypeExtra
              v-if="
                $userCheckAccess({
                  abilities: 'edit_hr',
                })
              "
              :create="true"
            />
            <EmployeesGroupSelectWorkTypeExtraTable
              v-if="employeeGroupWorkPeriods.length"
              :items="employeeGroupWorkPeriods"
            />
          </div>
        </transition-group>
      </div>
    </div>
  </TemplateView>
</template>

<script>
import TemplateView from 'components/templates/TemplateView'
import EmployeesGroupCreateAndEditModal from 'components/employees/group/EmployeesGroupCreateAndEditModal'
import EmployeesGroupSelectTable from 'components/employees/group/select/EmployeesGroupSelectTable'
import EmployeesGroupSelectModalWorkTypeExtra from 'components/employees/group/select/EmployeesGroupSelectModalWorkTypeExtra'
import EmployeesGroupSelectWorkTypeExtraTable from 'components/employees/group/select/EmployeesGroupSelectWorkTypeExtraTable'

import Plug from 'components/Plug'
import LoadingAnimation from 'components/LoadingAnimation'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'employeesGroupSelect',
  components: {
    TemplateView,
    EmployeesGroupCreateAndEditModal,
    EmployeesGroupSelectModalWorkTypeExtra,
    EmployeesGroupSelectWorkTypeExtraTable,
    Plug,
    LoadingAnimation,
    EmployeesGroupSelectTable,
  },
  data() {
    // let textSelectAll = localStorage.web_common['checkbox']['vybrat-vse']
    return {
      emloyeesIdList: [],
      usersIdList: [],
      typesSelected: [],
      loading: true,
      loadingGroupShow: true,
    }
  },
  created() {
    this.onEmployeeGroupShow(this.$route.params.id).then(() => (this.loadingGroupShow = false))
    this.onEmployeeGroupWorkPeriods({
      group_id: this.$route.params.id,
      is_extra: 1,
    })
  },
  watch: {
    employeeGroupShow() {
      if (this.employeeGroupShow) {
        this.onEmployeesData()
      }
    },
  },
  computed: {
    ...mapState(['configData']),
    ...mapGetters('employeeGroup', ['employeeGroupShow', 'employeeGroupWorkPeriods']),
    ...mapState('chat', ['chatsList']),
    ...mapGetters('user', ['userData']),
    employeeGroupChat() {
      return this.chatsList.find(
        (i) =>
          i.metadata &&
          i.metadata.userGroup.type === 'employeeGroup' &&
          Number(i.metadata.userGroup.id) === Number(this.employeeGroupShow.id),
      )
    },
    userIsReadyToCreateChat() {
      return this.usersIdList.includes(this.userData.id)
    },
    skillsList() {
      return [
        {
          id: '01',
          name: this.localStorage.translations.pages.common['checkbox']['vybrat-vse'],
          children: [],
        },
      ]
    },
  },
  methods: {
    ...mapActions('chat', ['CREATE_chatGroup']),
    ...mapActions('employeeGroup', [
      'onEmployeeGroupShow',
      'onEmployeeGroupUpdate',
      'onEmployeeGroupWorkPeriods',
    ]),
    ...mapMutations('employeeGroup', ['setEmployeeGroupShow', 'setEmployeeGroupWorkPeriods']),
    onEmployeesData() {
      if (this.employeeGroupShow) {
        this.loading = true
        let skillsEmployee = []
        console.log(skillsEmployee)
        let employeesId = []
        let usersId = []
        for (var i = 0; i < this.employeeGroupShow.employees.length; i++) {
          let employeeWorkType = this.employeeGroupShow.employees[i].work_types
          skillsEmployee.push(...employeeWorkType)
          let employeeId = this.employeeGroupShow.employees[i].id
          let userId = this.employeeGroupShow.employees[i].user.id
          employeesId.push(employeeId)
          usersId.push(userId)
        }
        let typesId = this.employeeGroupShow.types.filter(
          (value, index, self) => self.indexOf(value) === index,
        )
        let skillsListAll = []
        for (let key in skillsEmployee) {
          if (skillsListAll.findIndex((obj) => obj.id === skillsEmployee[key].id) === -1) {
            let objSkills = {}
            objSkills['quantity'] = 1
            objSkills['id'] = skillsEmployee[key].id
            objSkills['name'] = skillsEmployee[key].name + ' ' + '(' + objSkills['quantity'] + ')'
            skillsListAll.push(objSkills)
          } else {
            let objSkillsReady =
              skillsListAll[skillsListAll.findIndex((obj) => obj.id === skillsEmployee[key].id)]
            const regex = '(' + objSkillsReady.quantity + ')'
            objSkillsReady.quantity += 1
            objSkillsReady.name =
              objSkillsReady.name.replace(regex, '(' + objSkillsReady.quantity) + ')'
          }
        }
        this.skillsList[0].children = skillsListAll
        this.emloyeesIdList = employeesId
        this.usersIdList = usersId
        this.typesSelected = typesId
        this.loading = false
      }
    },
    async onUpdateActiveSkills() {
      let data = {
        id: this.$route.params.id,
        name: this.employeeGroupShow.name,
        employees: this.emloyeesIdList,
        types: this.typesSelected
          .map((item) => item.id)
          .filter((value, index, self) => self.indexOf(value) === index),
      }
      this.onEmployeeGroupUpdate(data)
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common['notifications'][
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.onEmployeeGroupShow(this.$route.params.id)
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common['notifications']['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    onClickGroupChat() {
      // console.log('onClickGroupChat')
      if (this.employeeGroupChat) {
        // console.log('id', this.employeeGroupChat.id)
        this.$router.push({ name: 'chat', params: { id: this.employeeGroupChat.id } })
      } else {
        if (this.userIsReadyToCreateChat) {
          let data = {
            usersGroupType: 'employeeGroup',
            usersGroupId: String(this.employeeGroupShow.id),
          }
          this.CREATE_chatGroup({ data })
        }
      }
    },
  },
  destroyed() {
    this.setEmployeeGroupShow()
    this.setEmployeeGroupWorkPeriods()
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  &_row {
    &--grid {
      display: grid !important;
      gap: 30px;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: max-content;
      @media screen and (max-width: 1200px) {
        grid-template-columns: 1fr;
      }
    }
    &:first-of-type {
      padding-bottom: 30px;
      position: relative;
      &::before {
        content: '';
        width: 100vw;
        position: absolute;
        height: 1px;
        background-color: #6ab1d8;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &:nth-of-type(2) {
      padding: 30px 0;
      display: grid;
      row-gap: 20px;
    }
  }
  :deep().box {
    padding: 0 !important;
    max-height: 60vh;
    overflow-y: auto;
    .plug {
      padding: 12px;
      max-height: 50vh;
      line-height: 1;
    }
  }

  .items {
    display: grid;
    grid-template-rows: max-content auto max-content;
  }
  .btnGroup {
    display: grid;
    // grid-template-columns: auto auto auto;
    grid-column-gap: 30px;
    height: max-content;
  }
  .groupGrid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
    height: max-content;
  }
}
</style>
